import Input from "../../components/Input";
import { createInvoice, GetStInvNum } from "../../actions/studensts";
import { getInvoiceNumber } from "../../actions/studensts";
import ActionButtonForward from "./ActionButtonsForward";
import ActionButtons from "./ActionButtons";
import AlertDenger from "../../components/AlertDenger";
import AlertSuccess from "../../components/AlertSuccess";
import Loading from "../../components/Loading";
import { useEffect, useState } from "react";

const exam_name = [
  "ACT1 One Trial Certificate",
  "ACT1 Super Score Certificate",
  "ACT1 Matching Certificate",
];

const initialValue = {
  exam_name: exam_name[0],
  month: "",
  year: "",
  act1: false,
  act1_copy_number: 0,
  act1Crt: 0,
  act2: false,
  act2Crt: 0,
  act2_month: "",
  act2_year: "",
  subject: "",
  act2_copy_number: 0,
  admin_fees: 0,
  shipping: 0,
  moe_auth: false,
  moe1_copy_number: 0,
  moe1_number: 0,
  moe2_copy_number: 0,
  moe2_number: 0,
  act2_id: "",
  act1_try: "",
  act2_try: "",
  discount: 0.0,
  invoice_type: "",
};

export default function Create({ id }) {
    // const url = "https://actmena.americanacademyeg.org/api/v2";
    // const url = "https://auth.americanacademyeg.us/api/v2";
    const url = "https://actmena.examauthentication.com/api/v2";
    // const url = "http://localhost:5000/api/v2";

  const [invoiceData, setInvoiceData] = useState({ ...initialValue, id });
  const [invoiceNum, setInvoiceNum] = useState(0);
  const [text, setText] = useState("");
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [showDengerAlert, setShowDengerAlert] = useState(false);
  const [loading, setLoading] = useState(false);
  const [created, setCreated] = useState(false);

  if (showSuccessAlert || showDengerAlert) {
    setTimeout(function () {
      setShowSuccessAlert(false);
      setShowDengerAlert(false);
      setLoading(false);
      if (showSuccessAlert) {
        setCreated(true);
      }
    }, 2000);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const res = await createInvoice(invoiceData);
    if (res.status === 200) {
      setShowSuccessAlert(true);
      setText(res.data.message);
    } else {
      setShowDengerAlert(true);
      setText(res.data.message);
    }
  };

  const handleInputChange = (e) => {
    const target = e.target;
    let value;
    if (target.type === "checkbox") {
      value = target.checked;
    } else if (target.type === "number") {
      value = parseFloat(target.value);
    } else {
      value = target.value;
    }

    const name = target.name;
    setInvoiceData({ ...invoiceData, [name]: value });
  };

  useEffect(() => {
    const fetchData = async () => {
      const data = await GetStInvNum(id);
      if (data) {
        const invoice_number1 = data.invoice_number[0].invoice_number;
        if (invoice_number1 !== null) {
          setInvoiceNum(invoice_number1);
        } else {
          const res = await getInvoiceNumber();
          const invoice_number2 = res.data.invoice_number;
          setInvoiceNum(invoice_number2);
        }
      }
    };

    fetchData();
  }, [id]);

  return (
    <div>
      <form
        onSubmit={handleSubmit}
        className="rounded-2xl bg-white/5 border border-white/10 backdrop-blur-sm p-6 my-4"
      >
        <div className="w-full flex items-center justify-center mb-4">
          {showSuccessAlert && <AlertSuccess text={text} />}
          {showDengerAlert && <AlertDenger text={text} />}
          <h2 className="text-white font-semibold text-lg">Invoice</h2>
        </div>
        <div className="text-center pb-4 text-slate-300">
          Invoice Number : {invoiceNum}
        </div>
        <div className="p-3 rounded-xl border border-white/10 bg-white/5">
          <Input
            type="checkbox"
            placeholder="ACT1"
            name="act1"
            required={false}
            onChange={handleInputChange}
            value={invoiceData.act1}
          />
          {invoiceData.act1 && (
            <>
              <div className="m-2 flex items-center justify-center">
                <label htmlFor="act_subject2" className="flex-auto text-slate-300">
                  <span className="text-red-400">*</span>
                  Exam Name:
                </label>
                <select
                  className="flex-initial p-2 ml-1 border border-white/10 rounded-xl bg-slate-900 text-white focus:outline-none focus:ring-1 focus:ring-indigo-500"
                  onChange={handleInputChange}
                  name="exam_name"
                  value={invoiceData.exam_name}
                >
                  {exam_name.map((exam, i) => (
                    <option value={exam} key={i} className="bg-slate-900 text-white">
                      {exam}
                    </option>
                  ))}
                </select>
              </div>
              <Input
                placeholder="No. of Trials ACT1"
                type="text"
                name="act1_try"
                value={invoiceData.act1_try}
                onChange={handleInputChange}
              />
              <Input
                placeholder="Month"
                type="text"
                name="month"
                value={invoiceData.month}
                onChange={handleInputChange}
              />
              <Input
                placeholder="Year"
                type="text"
                name="year"
                value={invoiceData.year}
                onChange={handleInputChange}
              />
              <div className="flex justify-between">
                <p className="p-2 pr-6 text-slate-300">ACT1 Crt Number: </p>
                <div className="flex">
                  <Input
                    placeholder="No Need"
                    type="radio"
                    name="act1Crt"
                    value="0"
                    onChange={handleInputChange}
                  />
                  <Input
                    placeholder="Need One"
                    type="radio"
                    name="act1Crt"
                    value="1"
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              <Input
                placeholder="ACT1 Copies Number"
                type="number"
                name="act1_copy_number"
                value={invoiceData.act1_copy_number}
                onChange={handleInputChange}
              />
            </>
          )}
        </div>
        <div className="mt-3 p-3 rounded-xl border border-white/10 bg-white/5">
          <Input
            type="checkbox"
            placeholder="ACT2 Subject"
            name="act2"
            required={false}
            onChange={handleInputChange}
            value={invoiceData.act2}
          />
          {invoiceData.act2 && (
            <>
              <Input
                placeholder="ACT2 ID/Email"
                type="text"
                name="act2_id"
                value={invoiceData.act2_id}
                onChange={handleInputChange}
                required={false}
              />
              <Input
                placeholder="No. of Trials ACT2"
                type="text"
                name="act2_try"
                value={invoiceData.act2_try}
                onChange={handleInputChange}
              />
              <Input
                placeholder="ACT2 Subject Month"
                type="text"
                name="act2_month"
                value={invoiceData.act2_month}
                onChange={handleInputChange}
              />
              <Input
                placeholder="ACT2 Subject Year"
                type="text"
                name="act2_year"
                value={invoiceData.act2_year}
                onChange={handleInputChange}
              />
              <Input
                placeholder="ACT2 Subject "
                type="text"
                name="subject"
                value={invoiceData.subject}
                onChange={handleInputChange}
              />
              <div className="flex justify-between">
                <p className="p-2 pr-6 text-slate-300">ACT2 Crt Number: </p>
                <div className="flex">
                  <Input
                    placeholder="No Need"
                    type="radio"
                    name="act2Crt"
                    value="0"
                    onChange={handleInputChange}
                  />
                  <Input
                    placeholder="Need One"
                    type="radio"
                    name="act2Crt"
                    value="1"
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              <Input
                placeholder="ACT2 Copies Number"
                type="number"
                name="act2_copy_number"
                value={invoiceData.act2_copy_number}
                onChange={handleInputChange}
              />
            </>
          )}
        </div>
        <Input
          placeholder="Admin Fees"
          type="number"
          name="admin_fees"
          value={invoiceData.admin_fees}
          onChange={handleInputChange}
          float={true}
        />
        <Input
          placeholder="shipping"
          type="number"
          name="shipping"
          value={invoiceData.shipping}
          onChange={handleInputChange}
        />

        <Input
          placeholder="Discount"
          type="number"
          name="discount"
          value={invoiceData.discount}
          onChange={handleInputChange}
        />
        <div className="flex flex-wrap gap-3 mt-4">
          <button
            className="py-2 px-4 bg-indigo-600 hover:bg-indigo-500 text-white rounded-lg
                     font-medium text-sm transition-colors disabled:bg-white/10
                     disabled:text-slate-500 disabled:cursor-not-allowed"
            type="submit"
            disabled={loading}
          >
            {!loading ? "Create" : <Loading />}
          </button>
          <button
            className="py-2 px-4 bg-white/10 hover:bg-white/15 text-white rounded-lg
                     border border-white/10 font-medium text-sm transition-colors
                     disabled:bg-white/5 disabled:text-slate-600 disabled:cursor-not-allowed"
            disabled={!created}
          >
            <a
              href={`${url}/invoice/main/download/${id}`}
              target="_blank"
              onClick={(e) => { if (!created) e.preventDefault(); }}
              rel="noreferrer"
            >
              Download Main
            </a>
          </button>
        </div>
      </form>
      <div className="flex flex-wrap gap-3 mt-4">
        <a
          className="py-2 px-4 bg-white/10 hover:bg-white/15 text-white rounded-lg
                    border border-white/10 font-medium text-sm transition-colors"
          href={`${url}/id_image/${id}`}
          target="_blank"
          rel="noreferrer"
        >
          Download ID Image
        </a>
        <a
          className="py-2 px-4 bg-white/10 hover:bg-white/15 text-white rounded-lg
                    border border-white/10 font-medium text-sm transition-colors"
          href={`${url}/letter_image/${id}`}
          target="_blank"
          rel="noreferrer"
        >
          Download Enrollment Image
        </a>
      </div>
      <div className="flex gap-4 mt-4 justify-center">
        <ActionButtonForward />
        <ActionButtons />
      </div>
    </div>
  );
}
